<template>
    <v-app id="keep">
        <v-app-bar color="darkgreen">
            <v-app-bar-nav-icon @click="toggleNavigationDrawer" color="white"></v-app-bar-nav-icon>
            <img
                src="../static/images/newInvaioLogo.webp"
                style="width: 180px; cursor: pointer"
                @click="navHome"
            />
            <p @click="navHome" class="logoText mb-n3 ml-n4" v-html="logoText()"></p>
            <v-spacer></v-spacer>
            <v-text-field
                clearable
                variant="solo"
                flat
                hide-details
                ref="search"
                v-if="isAuthenticated"
                v-bind:label="experimentSelected() ? 'Search or scan' : 'Search'"
                v-model="computedGlobalSearch"
                prepend-inner-icon="$magnify"
                bg-color="white"
                color="darkgreen"
            ></v-text-field>
            <v-btn class="ml-2" v-if="experimentAnalyze()" v-on:click="analyzeNow" color="info"
                >Analyze</v-btn
            >

            <v-spacer></v-spacer>
            <v-menu location="bottom end">
                <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" class="email" variant="text">
                        {{ $store.getters.getEmail }}
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="profile">
                        <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="logout">
                        <v-list-item-title>Logout</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="refreshSession">
                        <v-list-item-title>Refresh Session</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>

        <v-navigation-drawer
            v-model="isNavigationDrawerOpen"
            location="left"
            class="sidebar bg-grey-lighten-4"
            width="250"
        >
            <navigation-menu></navigation-menu>
        </v-navigation-drawer>

        <v-main>
            <v-container style="padding: 0; height: 100%" fluid class="bg-grey-lighten-4">
                <!-- Global Alert SnackBar -->
                <v-snackbar :timeout="alert.timeout" v-model="alert.status" location="top">
                    <div style="white-space: pre-line" class="mb-8 mx-8">
                        {{ alert.message }}
                    </div>
                    <template v-slot:actions>
                        <v-btn color="red" variant="text" @click="alert.status = false">
                            Close
                        </v-btn>
                    </template>
                </v-snackbar>

                <!-- Session expiration warning -->
                <SessionExpirationDialog />

                <!-- Global loading -->
                <v-dialog v-model="loading.status" width="20vw" color="darkgreen" persistent style="z-index: 999999">
                    <div class="text-center loading" style="overflow: hidden">
                        <v-icon @click="closeLoading" color="grey-lighten-1" style="float: right"
                            >$close</v-icon
                        >
                        <v-progress-circular
                            style="background-color: white; margin: 20px"
                            :size="250"
                            :width="15"
                            color="darkgreen"
                            indeterminate
                        >
                            <strong>
                                {{ loading.message }} <br />
                                Please wait...
                            </strong>
                        </v-progress-circular>
                        <img
                            id="mascot"
                            style="width: 75%; object-fit: contain; cursor: pointer; padding: 20px"
                        />
                    </div>
                </v-dialog>

                <!-- Content area -->
                <router-view v-bind:search="globalSearch" />
            </v-container>
        </v-main>
    </v-app>
</template>

<script setup>
import { onErrorCaptured } from "vue";
import { useToast } from "vue-toastification";
import _ from "lodash";

const toast = useToast();

onErrorCaptured((err, instance, info) => {
    console.log(err, instance, info);
    const responseErrorMsg = _.get(err, "response.data.error");
    if (responseErrorMsg) {
        if (responseErrorMsg.message) {
          toast.error(responseErrorMsg.message, { timeout: false });
        } else {
          toast.error(responseErrorMsg, { timeout: false });
        }
    } else {
        toast.error(err.message, { timeout: false });
    }
});

</script>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import { EventBus } from "./lib/event-bus";
import NavigationMenu from "./components/NavigationMenu/NavigationMenu.vue";
import config from "./config";
import axios from "./lib/apiAxios";
import { defineComponent, nextTick } from "vue";
import SessionExpirationDialog from "./components/Auth/SessionExpirationDialog.vue";

export default defineComponent({
    components: {
        SessionExpirationDialog,
        NavigationMenu,
    },

    mounted() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize(); // Initialize on load
    },

    beforeUnmount() {
        window.removeEventListener("resize", this.handleResize);
    },

    methods: {
        ...mapActions(["logout", "refreshSession", "closeNavigationDrawer", "openNavigationDrawer", "setGlobalSearch"]),
        ...mapMutations({
            setNavigationDrawer: "setNavigationDrawer",
        }),
        toggleNavigationDrawer() {
            if (this.isNavigationDrawerOpen) {
                this.closeNavigationDrawer();
            } else {
                this.openNavigationDrawer();
            }
        },
        handleResize() {
            if (window.innerWidth < 1024) {
                this.closeNavigationDrawer();
            } else {
                this.openNavigationDrawer();
            }
        },
        profile() {
            this.$router.push({ path: "/user/profile" });
        },
        link: function (url) {
            console.log(url);
            this.$router.push({ path: url });
        },
        logoText: function () {
            if (config.banner) {
                return `(${config.banner})`;
            } else {
                return "";
            }
        },
        analyzeNow: function () {
            axios
                .get(`/experiment/analysis/excised/${this.$route.params.code}`)
                .then((response) => {
                    console.log("~~~~~~~~~~~~~ response");
                    let message = response.data.status;
                    EventBus.$emit("message", { message: message });
                    console.log(response);
                });
        },
        experimentSelected: function () {
            if (this.$route.params.code && !this.$route.params.qrCode) {
                return true;
            }
            return false;
        },
        experimentAnalyze: function () {
            let acceptedTypes = [
                "bfi_6mMxyyTb",
                "bfi_fr1eyXaR",
                "bfi_oSuQO3zs",
                "bfi_57zxbkC6",
                "bfi_GIJu9PTy",
                "bfi_1e5J9sQI",
                "bfi_1e5J9sQI",
                "bfi_r2Ikak9w",
                "bfi_8aB2gpy1",
                "bfi_v4W7CvK4",
                "bfi_ONOlEEyI",
            ];
            if (acceptedTypes.includes(this.protocolId)) {
                return true;
            }
            return false;
        },
        navHome() {
            this.$router.push({ path: "/" }).catch(() => {});
        },
        closeLoading() {
            this.loading = {
                counter: 0,
                status: false,
                message: null,
            };
        },
    },

    created: function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const THIS = this;
        EventBus.$on("protocol_type", (data) => {
            console.log("setting assay type");
            console.log(data);
            THIS.protocolId = data.protocolId;
        });
        EventBus.$on("globalAlert", (data) => {
            let message;
            if (data.isAxiosError) {
                // AxiosErrors
                // response is the response object
                // response.data is the top-level data structure from the server
                // response.data.error is the error object from the server
                // our errors should have a `message` property on the `error` object
                message = data.response.data.error.message;
            } else {
                message = data;
            }
            const isErrorAlert = message && message.toLowerCase().includes("error");
            this.alert.message = message;
            this.alert.timeout = isErrorAlert ? -1 : 5000;
            this.alert.status = true;
        });
        EventBus.$on("globalLoadScreen", (data) => {
            // The maths here is to handle stacked loading screens when multiple API requests are made at the
            // same time. Keeps a count of how many times the loading screen was requested to be shown, and
            // only closes the screen once all loading requests have been dismissed
            if (data.status) {
                this.loading.status = true;
                this.loading.counter++;
                // Random mascot - what the heck, let's change it every time.
                nextTick(() => {
                    const mascotImgElement = document.getElementById("mascot");
                    if (mascotImgElement) {
                        const mascot = `/static/images/${this.loadingMascotArray[Math.floor(Math.random() * this.loadingMascotArray.length)]}.webp`;
                        mascotImgElement.src = mascot;
                    }
                });
            } else {
                this.loading.counter--;
                if (this.loading.counter < 0) {
                    // hot reloading does weird things with state while making API calls, resulting in negative counts.
                    this.loading.counter = 0;
                }
                if (this.loading.counter < 1) {
                    this.loading.status = false;
                }
            }
            this.loading.message = data.message;
        });
    },

    computed: {
        ...mapGetters(["isAuthenticated"]),
        ...mapState(["navigationDrawer", "globalSearch"]),
        isNavigationDrawerOpen: {
            get() {
                return this.navigationDrawer;
            },
            set(value) {
                this.setNavigationDrawer(value);
            },
        },
        computedGlobalSearch: {
            get() {
                return this.globalSearch;
            },
            set(value) {
                this.setGlobalSearch(value);
            }
        }
    },

    data: function () {
        return {
            alert: {
                status: false,
                message: undefined,
            },
            loadingCounter: 0,
            loading: {
                counter: 0,
                status: false,
                message: null,
            },
            drawer: null,
            protocolId: null,
            loadingMascotArray: ["sloth", "snail", "tortoise"],
            qrAlert: {
                status: false,
                message: "",
            },
        };
    },

    props: {
        source: String,
    },
});
</script>

<style>
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}
.v-list__tile__title {
    font-size: 1.4em;
}
.loading {
    background-color: white;
    border: 2px solid darkgreen;
    border-radius: 10px;
}
.logoText {
    font-family: "Century Gothic", sans-serif;
    font-size: 20px;
    color: white;
    font-weight: bold;
    cursor: pointer;
}
.email {
    background-color: transparent;
    color: #c5e0c6 !important;
}
</style>
